<button
  [ngClass]="{ loading: isLoading() }"
  [attr.data-testid]="testId()"
  [attr.theme]="theme()"
  [disabled]="isLoading()"
  [attr.aria-label]="isLoading() ? 'Loading' : text()"
  (click)="handleClick()"
  ftrTooltip
  alignment="auto"
  [showDash]="false"
  [message]="tooltipMessage() ?? ''"
  [forceDisplayState]="shouldShowTooltip() ? undefined : 'hide'"
>
  <div class="main">
    @if (iconLeft(); as icon) {
      <svg [ftrIcon]="icon" [iconSize]="18"></svg>
    }
    <span class="text" [attr.aria-label]="text()">{{ text() }}</span>
    @if (iconRight(); as icon) {
      <svg [ftrIcon]="icon" [iconSize]="18"></svg>
    }
  </div>
  @if (isLoading()) {
    <div class="loader" @animateLoader>
      <div class="loader-inner">
        <div class="background"></div>
        <div class="line1"></div>
        <div class="line2"></div>
      </div>
    </div>
  }
</button>
